'use client';

import clsx from 'clsx';
import { useState, useEffect } from 'react';

const injuryWords = [
  'car accident?',
  'truck accident?',
  'slip and fall?',
  'work accident?',
  'bike accident?',
];

const WORD_DURATION = 450;
const STAGGER = 90;
const HOLD_DURATION = 2500;

type Phase = 'entering' | 'holding' | 'exiting';

export function TitleAnimation({ className }: { className?: string }) {
  const [index, setIndex] = useState(0);
  const [phase, setPhase] = useState<Phase>('entering');

  const words = injuryWords[index].split(' ');
  const n = words.length;

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (phase === 'entering') {
      timer = setTimeout(() => setPhase('holding'), WORD_DURATION + (n - 1) * STAGGER);
    } else if (phase === 'holding') {
      timer = setTimeout(() => setPhase('exiting'), HOLD_DURATION);
    } else {
      timer = setTimeout(
        () => {
          setIndex((i) => (i + 1) % injuryWords.length);
          setPhase('entering');
        },
        WORD_DURATION + (n - 1) * STAGGER
      );
    }

    return () => clearTimeout(timer);
  }, [phase, n]);

  return (
    <div className="flex items-start gap-3">
      {words.map((word, i) => {
        const delay = i * STAGGER;

        return (
          <div key={`${index}-${i}`} className={clsx('overflow-hidden h-[52.8px]', className)}>
            <span
              style={
                phase !== 'holding'
                  ? {
                      display: 'block',
                      animationName: phase === 'entering' ? 'title-slide-in' : 'title-slide-out',
                      animationDuration: `${WORD_DURATION}ms`,
                      animationDelay: `${delay}ms`,
                      animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
                      animationFillMode: 'both',
                    }
                  : { display: 'block' }
              }
            >
              {word}
            </span>
          </div>
        );
      })}
    </div>
  );
}
export default TitleAnimation;
